import React from 'react';

export function Learning () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        stroke="#717171"
        strokeLinejoin="round"
        d="M.5 10L14 4l13.5 6L14 16 .5 10z"
      />
      <path
        fill="#717171"
        d="M14.045 10.498a.5.5 0 10-.09-.996l.09.996zM3 11l-.045-.498A.5.5 0 002.5 11H3zm10.955-1.498l-11 1 .09.996 11-1-.09-.996zM2.5 11v9h1v-9h-1z"
      />
      <path
        stroke="#717171"
        strokeLinejoin="round"
        d="M6 12.5v6.892c0 .69.355 1.33.94 1.695v0c4.32 2.7 9.8 2.7 14.12 0v0c.585-.365.94-1.006.94-1.695V12.5"
      />
      <path stroke="#717171" d="M4 21a1 1 0 11-2 0 1 1 0 012 0z" />
      <path
        stroke="#717171"
        strokeLinejoin="round"
        d="M2.5 21.5l-1 3.5.551.184a3 3 0 001.898 0L4.5 25l-1-3.5"
      />
    </svg>
  );
}
